module.exports = __webpack_public_path__ + "img/main_logo.c785c6d8.svg";